<template>
  <div class="range-year-rate">
    <el-input v-model="rate"
              @focus="onfocus"
              @blur="onblur"
              :disabled="disabled">
      <div class="range-year-rate-1"
           slot="prepend">
        <type-year v-model="yearStart"
                   :disabled="disabled"
                   :hints="'起始年'"></type-year>
      </div>
      <div class="range-year-rate-2"
           slot="prepend">
        <type-year v-model="yearEnd"
                   :disabled="disabled"
                   :hints="'结束年'"></type-year>
      </div>
      <template slot="append">%</template>
    </el-input>
  </div>
</template>
<style>
.range-year-rate-1 {
  width: 50px;
  margin: 1px 0 4px 0;
}
.range-year-rate-2 {
  width: 50px;
  margin: 4px 0 1px 0;
}
.range-year-rate {
  width: 220px;
}
</style>
<script>
import LibProductItem from '../../../minxin/ProductItem';
import TypeYear from './TypeYear';

export default {
  name: "ProductItemTypeRangeAge",
  components: {
    TypeYear
  },
  props: {
    value: Object
  },
  mixins: [LibProductItem],
  data() {
    return {
      rate: 0
    }
  },
  created() {
    this.rate = this.parseRate(this.currentValue.rate)
  },
  computed: {
    yearStart: {
      get: function () { return this.currentValue.start_year },
      set: function (n) {
        let v = this.currentValue
        v.start_year = n
        this.$emit('input', v)
      }
    },
    yearEnd: {
      get: function () { return this.currentValue.end_year },
      set: function (n) {
        let v = this.currentValue
        v.end_year = n
        this.$emit('input', v)
      }
    },
    currentValue() {
      return JSON.parse(JSON.stringify(this.value || {})) || {}
    }
  },
  methods: {
    onfocus() {
      this.rate = this.parseRate(this.currentValue.rate)
    },
    onblur() {
      let n = this.rate
      if (/^\d{0,6}(\.\d{0,9})?$/.exec(n) !== null) {
        if (n === "") {
          n = null
        } else {
          n = Math.round((parseFloat(n) || 0) / 100 * 1000000) / 1000000
        }

        let v = this.currentValue
        v.rate = n
        this.$emit('input', v)
        this.rate = this.parseRate(v.rate)
      } else {
        this.rate = this.parseRate(this.currentValue.rate)
      }
    },
    parseRate(r) {
      if (r !== null && r !== undefined) {
        r = Math.round(r * 100000000) / 1000000
      }

      return r
    }
  }
}
</script>

